module.exports = __webpack_public_path__ + "img/s8Bg4.441090e7.jpg";